import { type Context, createContext } from 'react';

/**
 * @public
 */
export type ChipGroupContextProps = {
  /** The keys of currently visible chips. */
  visibleKeys: string[];
  /** The keys of currently hidden chips. */
  hiddenKeys: string[];
};

/**
 * The `ChipGroupContext` provides access to the number of currently visible / hidden chips.
 * @internal
 */
export const ChipGroupContext: Context<ChipGroupContextProps> =
  createContext<ChipGroupContextProps>({
    hiddenKeys: [],
    visibleKeys: [],
  });
